/* This file is auto-generated, manual edits in this file will be overwritten! */

export const i18nKeys = {
  login: {
    title: 'login.title',
    forgot_password: 'login.forgot_password',
    signin: 'login.signin',
    no_account: 'login.no_account',
    ask_account: 'login.ask_account',
    profile: 'login.profile',
    back: 'login.back',
  },
  onboarding: {
    review_company: {
      title: 'onboarding.review_company.title',
      introduction: 'onboarding.review_company.introduction',
      assistant: {
        title: 'onboarding.review_company.assistant.title',
        content: 'onboarding.review_company.assistant.content',
      },
      legal: {
        annual_turnover: {
          less_forty:
            'onboarding.review_company.legal.annual_turnover.less_forty',
          less_hundred:
            'onboarding.review_company.legal.annual_turnover.less_hundred',
          less_two_hundred_fifty:
            'onboarding.review_company.legal.annual_turnover.less_two_hundred_fifty',
          less_one_k:
            'onboarding.review_company.legal.annual_turnover.less_one_k',
          less_three_k:
            'onboarding.review_company.legal.annual_turnover.less_three_k',
          less_ten_k:
            'onboarding.review_company.legal.annual_turnover.less_ten_k',
          less_hundred_k:
            'onboarding.review_company.legal.annual_turnover.less_hundred_k',
          over_hundred_k:
            'onboarding.review_company.legal.annual_turnover.over_hundred_k',
        },
        net_income: {
          less_five: 'onboarding.review_company.legal.net_income.less_five',
          less_ten: 'onboarding.review_company.legal.net_income.less_ten',
          less_fifty: 'onboarding.review_company.legal.net_income.less_fifty',
          less_hundred_fifty:
            'onboarding.review_company.legal.net_income.less_hundred_fifty',
          less_five_hundred_fifty:
            'onboarding.review_company.legal.net_income.less_five_hundred_fifty',
          over_five_hundred_fifty:
            'onboarding.review_company.legal.net_income.over_five_hundred_fifty',
        },
        number_of_employee: {
          less_ten:
            'onboarding.review_company.legal.number_of_employee.less_ten',
          less_hundred:
            'onboarding.review_company.legal.number_of_employee.less_hundred',
          less_two_hundred_fifty:
            'onboarding.review_company.legal.number_of_employee.less_two_hundred_fifty',
          over_two_hundred_fifty:
            'onboarding.review_company.legal.number_of_employee.over_two_hundred_fifty',
        },
        sector: {
          '0170Z': 'onboarding.review_company.legal.sector.0170Z',
          '0610Z': 'onboarding.review_company.legal.sector.0610Z',
          '0620Z': 'onboarding.review_company.legal.sector.0620Z',
          '0710Z': 'onboarding.review_company.legal.sector.0710Z',
          '0721Z': 'onboarding.review_company.legal.sector.0721Z',
          '0729Z': 'onboarding.review_company.legal.sector.0729Z',
          '0891Z': 'onboarding.review_company.legal.sector.0891Z',
          '0899Z': 'onboarding.review_company.legal.sector.0899Z',
          '0910Z': 'onboarding.review_company.legal.sector.0910Z',
          '1910Z': 'onboarding.review_company.legal.sector.1910Z',
          '1920Z': 'onboarding.review_company.legal.sector.1920Z',
          '2013A': 'onboarding.review_company.legal.sector.2013A',
          '2015Z': 'onboarding.review_company.legal.sector.2015Z',
          '2042Z': 'onboarding.review_company.legal.sector.2042Z',
          '2051Z': 'onboarding.review_company.legal.sector.2051Z',
          '2053Z': 'onboarding.review_company.legal.sector.2053Z',
          '2351Z': 'onboarding.review_company.legal.sector.2351Z',
          '2352Z': 'onboarding.review_company.legal.sector.2352Z',
          '2420Z': 'onboarding.review_company.legal.sector.2420Z',
          '2540Z': 'onboarding.review_company.legal.sector.2540Z',
          '2591Z': 'onboarding.review_company.legal.sector.2591Z',
          '2814Z': 'onboarding.review_company.legal.sector.2814Z',
          '3011Z': 'onboarding.review_company.legal.sector.3011Z',
          '3030Z': 'onboarding.review_company.legal.sector.3030Z',
          '3040Z': 'onboarding.review_company.legal.sector.3040Z',
          '3250A': 'onboarding.review_company.legal.sector.3250A',
          '3315Z': 'onboarding.review_company.legal.sector.3315Z',
          '3316Z': 'onboarding.review_company.legal.sector.3316Z',
          '3317Z': 'onboarding.review_company.legal.sector.3317Z',
          '3320A': 'onboarding.review_company.legal.sector.3320A',
          '3522Z': 'onboarding.review_company.legal.sector.3522Z',
          '3523Z': 'onboarding.review_company.legal.sector.3523Z',
          '4291Z': 'onboarding.review_company.legal.sector.4291Z',
          '4313Z': 'onboarding.review_company.legal.sector.4313Z',
          '4612A': 'onboarding.review_company.legal.sector.4612A',
          '4612B': 'onboarding.review_company.legal.sector.4612B',
          '4614Z': 'onboarding.review_company.legal.sector.4614Z',
          '4618Z': 'onboarding.review_company.legal.sector.4618Z',
          '4632A': 'onboarding.review_company.legal.sector.4632A',
          '4632B': 'onboarding.review_company.legal.sector.4632B',
          '4632C': 'onboarding.review_company.legal.sector.4632C',
          '4645Z': 'onboarding.review_company.legal.sector.4645Z',
          '4651Z': 'onboarding.review_company.legal.sector.4651Z',
          '4652Z': 'onboarding.review_company.legal.sector.4652Z',
          '4669B': 'onboarding.review_company.legal.sector.4669B',
          '4671Z': 'onboarding.review_company.legal.sector.4671Z',
          '4672Z': 'onboarding.review_company.legal.sector.4672Z',
          '4675Z': 'onboarding.review_company.legal.sector.4675Z',
          '5010Z': 'onboarding.review_company.legal.sector.5010Z',
          '5020Z': 'onboarding.review_company.legal.sector.5020Z',
          '5030Z': 'onboarding.review_company.legal.sector.5030Z',
          '5040Z': 'onboarding.review_company.legal.sector.5040Z',
          '5110Z': 'onboarding.review_company.legal.sector.5110Z',
          '5121Z': 'onboarding.review_company.legal.sector.5121Z',
          '5222Z': 'onboarding.review_company.legal.sector.5222Z',
          '5223Z': 'onboarding.review_company.legal.sector.5223Z',
          '5229B': 'onboarding.review_company.legal.sector.5229B',
          '6202B': 'onboarding.review_company.legal.sector.6202B',
          '6203Z': 'onboarding.review_company.legal.sector.6203Z',
          '7022Z': 'onboarding.review_company.legal.sector.7022Z',
          '7112B': 'onboarding.review_company.legal.sector.7112B',
          '7430Z': 'onboarding.review_company.legal.sector.7430Z',
          '7734Z': 'onboarding.review_company.legal.sector.7734Z',
          '7735Z': 'onboarding.review_company.legal.sector.7735Z',
          '7911Z': 'onboarding.review_company.legal.sector.7911Z',
          '7912Z': 'onboarding.review_company.legal.sector.7912Z',
          '7990Z': 'onboarding.review_company.legal.sector.7990Z',
          '8230Z': 'onboarding.review_company.legal.sector.8230Z',
          '9512Z': 'onboarding.review_company.legal.sector.9512Z',
        },
      },
      search_bce: 'onboarding.review_company.search_bce',
      constitution_example: 'onboarding.review_company.constitution_example',
    },
    wizard: {
      review_company: 'onboarding.wizard.review_company',
      review_beneficiary: 'onboarding.wizard.review_beneficiary',
      confirm_company: 'onboarding.wizard.confirm_company',
      beneficiary_documents: 'onboarding.wizard.beneficiary_documents',
      start_onboarding: 'onboarding.wizard.start_onboarding',
      nav: {
        title: 'onboarding.wizard.nav.title',
        introduction: 'onboarding.wizard.nav.introduction',
        success_title: 'onboarding.wizard.nav.success_title',
        success_introduction: 'onboarding.wizard.nav.success_introduction',
      },
      review_onboarding: 'onboarding.wizard.review_onboarding',
    },
    review_beneficiary: {
      title: 'onboarding.review_beneficiary.title',
      introduction: 'onboarding.review_beneficiary.introduction',
      select_beneficiary: 'onboarding.review_beneficiary.select_beneficiary',
      assistant: {
        title: 'onboarding.review_beneficiary.assistant.title',
        content: 'onboarding.review_beneficiary.assistant.content',
      },
      help: {
        title: 'onboarding.review_beneficiary.help.title',
        content: 'onboarding.review_beneficiary.help.content',
        link: 'onboarding.review_beneficiary.help.link',
      },
      no_beneficiary: {
        title: 'onboarding.review_beneficiary.no_beneficiary.title',
        introduction:
          'onboarding.review_beneficiary.no_beneficiary.introduction',
        cta: 'onboarding.review_beneficiary.no_beneficiary.cta',
      },
      none: 'onboarding.review_beneficiary.none',
      select: {
        title: 'onboarding.review_beneficiary.select.title',
      },
      add_manually: 'onboarding.review_beneficiary.add_manually',
      form: {
        title: 'onboarding.review_beneficiary.form.title',
      },
      document: {
        title: 'onboarding.review_beneficiary.document.title',
        decription: 'onboarding.review_beneficiary.document.decription',
        example: 'onboarding.review_beneficiary.document.example',
      },
    },
    confirm_company: {
      agree_terms_and_conditions:
        'onboarding.confirm_company.agree_terms_and_conditions',
      title: 'onboarding.confirm_company.title',
      introduction: 'onboarding.confirm_company.introduction',
      assistant: {
        title: 'onboarding.confirm_company.assistant.title',
        content: 'onboarding.confirm_company.assistant.content',
      },
    },
    documents: {
      proof_of_identity: 'onboarding.documents.proof_of_identity',
      proof_of_address: 'onboarding.documents.proof_of_address',
      title: 'onboarding.documents.title',
      introduction: 'onboarding.documents.introduction',
      identity_card_example: 'onboarding.documents.identity_card_example',
      passport_example: 'onboarding.documents.passport_example',
      address_proof_example: 'onboarding.documents.address_proof_example',
      identity: 'onboarding.documents.identity',
      passport: 'onboarding.documents.passport',
      assistant: {
        title: 'onboarding.documents.assistant.title',
        content: 'onboarding.documents.assistant.content',
      },
      cards: {
        identity: {
          introduction: 'onboarding.documents.cards.identity.introduction',
        },
        address: {
          introduction: 'onboarding.documents.cards.address.introduction',
        },
      },
      quality: {
        title: 'onboarding.documents.quality.title',
        spec1: 'onboarding.documents.quality.spec1',
        spec2: 'onboarding.documents.quality.spec2',
        spec3: 'onboarding.documents.quality.spec3',
        spec4: 'onboarding.documents.quality.spec4',
      },
    },
    confirmation_dialog: {
      title: 'onboarding.confirmation_dialog.title',
      content: 'onboarding.confirmation_dialog.content',
      agree_terms_and_conditions:
        'onboarding.confirmation_dialog.agree_terms_and_conditions',
    },
    success: {
      title: 'onboarding.success.title',
      introduction: 'onboarding.success.introduction',
      card: {
        title: 'onboarding.success.card.title',
        subtitle: 'onboarding.success.card.subtitle',
      },
      question: 'onboarding.success.question',
      contact: 'onboarding.success.contact',
      complete_steps: {
        title: 'onboarding.success.complete_steps.title',
        introduction: 'onboarding.success.complete_steps.introduction',
      },
    },
    welcome_page: {
      introduction: 'onboarding.welcome_page.introduction',
      document_list: {
        title: 'onboarding.welcome_page.document_list.title',
        item1: 'onboarding.welcome_page.document_list.item1',
        item2: 'onboarding.welcome_page.document_list.item2',
        item3: 'onboarding.welcome_page.document_list.item3',
        item4: 'onboarding.welcome_page.document_list.item4',
      },
      app_submitted: {
        title: 'onboarding.welcome_page.app_submitted.title',
        introduction: 'onboarding.welcome_page.app_submitted.introduction',
      },
      assistant: {
        title: 'onboarding.welcome_page.assistant.title',
        content: 'onboarding.welcome_page.assistant.content',
      },
    },
    review_page: {
      introduction: 'onboarding.review_page.introduction',
      document_list: {
        title: 'onboarding.review_page.document_list.title',
      },
      assistant: {
        title: 'onboarding.review_page.assistant.title',
        content: 'onboarding.review_page.assistant.content',
      },
    },
    start_kyc: 'onboarding.start_kyc',
    kyc_error: 'onboarding.kyc_error',
    kyc_error_info: 'onboarding.kyc_error_info',
    kyc_loading: 'onboarding.kyc_loading',
    kyc_loading_info: 'onboarding.kyc_loading_info',
    start_kyc_intro: 'onboarding.start_kyc_intro',
    kyc_success: 'onboarding.kyc_success',
    kyc_success_info: 'onboarding.kyc_success_info',
  },
  common: {
    company_email: 'common.company_email',
    address: 'common.address',
    legal_sector: 'common.legal_sector',
    number_of_employees: 'common.number_of_employees',
    legal_net_income: 'common.legal_net_income',
    legal_annual_turnover: 'common.legal_annual_turnover',
    legal_registration_date: 'common.legal_registration_date',
    next: 'common.next',
    previous: 'common.previous',
    firstname: 'common.firstname',
    lastname: 'common.lastname',
    occupation: 'common.occupation',
    contact_us: 'common.contact_us',
    confirm: 'common.confirm',
    email: 'common.email',
    password: 'common.password',
    vat: 'common.vat',
    loading: 'common.loading',
    reset_password: 'common.reset_password',
    errors: {
      email_invalid: 'common.errors.email_invalid',
      password: {
        passwords_mismatch: 'common.errors.password.passwords_mismatch',
        password_too_short: 'common.errors.password.password_too_short',
        password_capital_required:
          'common.errors.password.password_capital_required',
        password_number_required:
          'common.errors.password.password_number_required',
        password_special_character_required:
          'common.errors.password.password_special_character_required',
      },
      code_invalid: 'common.errors.code_invalid',
      code_required: 'common.errors.code_required',
      field_required: 'common.errors.field_required',
      vat_invalid: 'common.errors.vat_invalid',
      terms_and_condition_required:
        'common.errors.terms_and_condition_required',
      field_not_equal_to: 'common.errors.field_not_equal_to',
      phone_number_invalid: 'common.errors.phone_number_invalid',
      unauthorized: {
        employee: 'common.errors.unauthorized.employee',
      },
      http_error: 'common.errors.http_error',
      crash_tracking: {
        title: 'common.errors.crash_tracking.title',
        cta: 'common.errors.crash_tracking.cta',
      },
      service_unavailable: {
        introduction: 'common.errors.service_unavailable.introduction',
        cta: 'common.errors.service_unavailable.cta',
        title: 'common.errors.service_unavailable.title',
      },
      title: 'common.errors.title',
      authentication: {
        title: 'common.errors.authentication.title',
      },
      auth: {
        reset_password: 'common.errors.auth.reset_password',
        email_invalid: 'common.errors.auth.email_invalid',
        password_invalid: 'common.errors.auth.password_invalid',
      },
    },
    country: 'common.country',
    submit: 'common.submit',
    cancel: 'common.cancel',
    full_name: 'common.full_name',
    status: 'common.status',
    shareholder_info: 'common.shareholder_info',
    phone_number: 'common.phone_number',
    employees: 'common.employees',
    add_employees: 'common.add_employees',
    terms_and_conditions: 'common.terms_and_conditions',
    privacy_policy: 'common.privacy_policy',
    nationality: 'common.nationality',
    national_registry_number: 'common.national_registry_number',
    date_of_birth: 'common.date_of_birth',
    place_of_birth: 'common.place_of_birth',
    gender: 'common.gender',
    mr: 'common.mr',
    mrs: 'common.mrs',
    city: 'common.city',
    postal_code: 'common.postal_code',
    proof_of_identity: 'common.proof_of_identity',
    proof_of_address: 'common.proof_of_address',
    example: 'common.example',
    front: 'common.front',
    back: 'common.back',
    finalize: 'common.finalize',
    document_type: 'common.document_type',
    operator: 'common.operator',
    fleet_manager: 'common.fleet_manager',
    done: 'common.done',
    consult: 'common.consult',
    faq: 'common.faq',
    support: 'common.support',
    country_code: 'common.country_code',
    empty_table: 'common.empty_table',
    role: {
      USER: 'common.role.USER',
      OPERATOR_ADMIN: 'common.role.OPERATOR_ADMIN',
      FLEET_MGR: 'common.role.FLEET_MGR',
      EMPLOYEE: 'common.role.EMPLOYEE',
    },
    bce: 'common.bce',
    constitution: 'common.constitution',
    congrats: 'common.congrats',
    issue: 'common.issue',
    upload_explaination: 'common.upload_explaination',
    legal_address: 'common.legal_address',
    add_beneficiary: 'common.add_beneficiary',
    home: 'common.home',
    documents: 'common.documents',
    onboarding: 'common.onboarding',
    preview: 'common.preview',
    outside_eu: 'common.outside_eu',
    yes: 'common.yes',
    no: 'common.no',
    economic_sanctions: 'common.economic_sanctions',
    resident_countries_sanctions: 'common.resident_countries_sanctions',
    involved_sanctions: 'common.involved_sanctions',
    entity_type_label: 'common.entity_type_label',
    entity_type: {
      REPORTING_FINANCIAL_INSTITUTION:
        'common.entity_type.REPORTING_FINANCIAL_INSTITUTION',
      NON_REPORTING_FINANCIAL_INSTITUTION:
        'common.entity_type.NON_REPORTING_FINANCIAL_INSTITUTION',
      ACTIVE_NON_FINANCIAL_ENTITY_GOVERNEMENT:
        'common.entity_type.ACTIVE_NON_FINANCIAL_ENTITY_GOVERNEMENT',
      ACTIVE_NON_FINANCIAL_ENTITY_OTHER:
        'common.entity_type.ACTIVE_NON_FINANCIAL_ENTITY_OTHER',
      PASSIVE_NON_FINANCIAL_ENTITY:
        'common.entity_type.PASSIVE_NON_FINANCIAL_ENTITY',
    },
    welcome: 'common.welcome',
    topup_wallet: 'common.topup_wallet',
    iban: 'common.iban',
    TagStatus: {
      PENDING: 'common.TagStatus.PENDING',
      POSITIVE: 'common.TagStatus.POSITIVE',
      NEGATIVE: 'common.TagStatus.NEGATIVE',
      NONE: 'common.TagStatus.NONE',
      CREATED: 'common.TagStatus.CREATED',
      SUGGESTED: 'common.TagStatus.SUGGESTED',
      CONFIRMED: 'common.TagStatus.CONFIRMED',
      VALIDATED: 'common.TagStatus.VALIDATED',
      REFUSED: 'common.TagStatus.REFUSED',
      CANCELED: 'common.TagStatus.CANCELED',
      STARTED: 'common.TagStatus.STARTED',
      IN_REVIEW: 'common.TagStatus.IN_REVIEW',
    },
    estimated_remaining_time: 'common.estimated_remaining_time',
    min: 'common.min',
    employees_list: 'common.employees_list',
    close: 'common.close',
    add: 'common.add',
    legal_form: 'common.legal_form',
    legal_name: 'common.legal_name',
    upload_explaination_part1: 'common.upload_explaination_part1',
    upload_explaination_part2: 'common.upload_explaination_part2',
    remove: 'common.remove',
    comments: 'common.comments',
    doctype: {
      ORGANISATION_CONSTITUTION: 'common.doctype.ORGANISATION_CONSTITUTION',
      ORGANISATION_BCE: 'common.doctype.ORGANISATION_BCE',
      ID_FRONT: 'common.doctype.ID_FRONT',
      ID_BACK: 'common.doctype.ID_BACK',
      PASSPORT: 'common.doctype.PASSPORT',
      PROOF_OF_ADDRESS: 'common.doctype.PROOF_OF_ADDRESS',
      US_PERSON_ADDITIONAL: 'common.doctype.US_PERSON_ADDITIONAL',
      PROXY_GRANTING_EMPLOYEE: 'common.doctype.PROXY_GRANTING_EMPLOYEE',
      RESIDENCE_PERMIT: 'common.doctype.RESIDENCE_PERMIT',
    },
    from: 'common.from',
    unauthorized: 'common.unauthorized',
    there_is: 'common.there_is',
    days: 'common.days',
    days_plural: 'common.days_plural',
    table: {
      employee: {
        search_placeholder: 'common.table.employee.search_placeholder',
      },
      filter_button: 'common.table.filter_button',
      active_filters: 'common.table.active_filters',
      clear_filters: 'common.table.clear_filters',
      organisation: {
        search_placeholder: 'common.table.organisation.search_placeholder',
      },
      expense: {
        search_placeholder: 'common.table.expense.search_placeholder',
      },
      search: 'common.table.search',
      merchants: {
        search_placeholder: 'common.table.merchants.search_placeholder',
      },
    },
    kyc_status: 'common.kyc_status',
    document: {
      expired_since: 'common.document.expired_since',
    },
    bank_label: 'common.bank_label',
    see_more: 'common.see_more',
    country_of_birth: 'common.country_of_birth',
    street: 'common.street',
    start_at: 'common.start_at',
    end_at: 'common.end_at',
    organisation_name: 'common.organisation_name',
    amount: 'common.amount',
    internal_payroll_id: 'common.internal_payroll_id',
    social_secretary_employee_reference:
      'common.social_secretary_employee_reference',
    merchants: 'common.merchants',
    transaction: 'common.transaction',
    transactions: 'common.transactions',
    card: 'common.card',
    created_at: 'common.created_at',
    merchant_name: 'common.merchant_name',
    budgets: 'common.budgets',
    expenses: 'common.expenses',
    updated_at: 'common.updated_at',
    add_all: 'common.add_all',
    remove_all: 'common.remove_all',
    social_secretary_name: 'common.social_secretary_name',
    social_secretary_employee_type: 'common.social_secretary_employee_type',
    SocialSecretaryEmployeeType: {
      WORKER: 'common.SocialSecretaryEmployeeType.WORKER',
      CLERK: 'common.SocialSecretaryEmployeeType.CLERK',
    },
    edit: 'common.edit',
    restriction_groups: 'common.restriction_groups',
    merchant_reference: 'common.merchant_reference',
    provider_name: 'common.provider_name',
    expense_category_code: 'common.expense_category_code',
    ExpenseCategoryCode: {
      bike: 'common.ExpenseCategoryCode.bike',
      car: 'common.ExpenseCategoryCode.car',
      motor_scooter: 'common.ExpenseCategoryCode.motor_scooter',
      kick_scooter: 'common.ExpenseCategoryCode.kick_scooter',
      public_transport: 'common.ExpenseCategoryCode.public_transport',
      taxi: 'common.ExpenseCategoryCode.taxi',
      parking: 'common.ExpenseCategoryCode.parking',
      car_rent_or_lease_long_term:
        'common.ExpenseCategoryCode.car_rent_or_lease_long_term',
      housing_interest: 'common.ExpenseCategoryCode.housing_interest',
      fuel_charging_parking_toll:
        'common.ExpenseCategoryCode.fuel_charging_parking_toll',
      company_lease_bike: 'common.ExpenseCategoryCode.company_lease_bike',
      parking_at_station: 'common.ExpenseCategoryCode.parking_at_station',
      fuel_or_charging: 'common.ExpenseCategoryCode.fuel_or_charging',
      equipment_purchase: 'common.ExpenseCategoryCode.equipment_purchase',
      'e-vehicle_purchase': 'common.ExpenseCategoryCode.e-vehicle_purchase',
      'e-vehicle_leasing': 'common.ExpenseCategoryCode.e-vehicle_leasing',
      housing_rent: 'common.ExpenseCategoryCode.housing_rent',
      unknown: 'common.ExpenseCategoryCode.unknown',
    },
    settings: 'common.settings',
    title: 'common.title',
    is_home_work: 'common.is_home_work',
    date: 'common.date',
    justification: 'common.justification',
    ValidationStatus: {
      APPROVED: 'common.ValidationStatus.APPROVED',
      REFUSED: 'common.ValidationStatus.REFUSED',
      NEED_MORE_INFO: 'common.ValidationStatus.NEED_MORE_INFO',
      PENDING: 'common.ValidationStatus.PENDING',
      NO_APPROVAL_REQUIRED: 'common.ValidationStatus.NO_APPROVAL_REQUIRED',
      MISSING_PROVIDER: 'common.ValidationStatus.MISSING_PROVIDER',
    },
    type: 'common.type',
    ExpenseType: {
      UNCATEGORIZED: 'common.ExpenseType.UNCATEGORIZED',
      MIXED: 'common.ExpenseType.MIXED',
      PRIVATE: 'common.ExpenseType.PRIVATE',
      PRO: 'common.ExpenseType.PRO',
    },
    wallet_amount: 'common.wallet_amount',
    KmAllowanceType: {
      LEGAL: 'common.KmAllowanceType.LEGAL',
      CUSTOM: 'common.KmAllowanceType.CUSTOM',
    },
    configuration: {
      automatic_expense_approval_limits: {
        card_pro_expense:
          'common.configuration.automatic_expense_approval_limits.card_pro_expense',
        app_pro_expense:
          'common.configuration.automatic_expense_approval_limits.app_pro_expense',
      },
      km_allowance: {
        enabled: 'common.configuration.km_allowance.enabled',
        fee_per_km: 'common.configuration.km_allowance.fee_per_km',
      },
    },
    social_secretary_reference: 'common.social_secretary_reference',
    merchant_code: 'common.merchant_code',
    product: 'common.product',
    program: 'common.program',
    source: 'common.source',
    service: 'common.service',
    programs: 'common.programs',
    true: 'common.true',
    false: 'common.false',
    used: 'common.used',
    activation_status: {
      ACTIVE: 'common.activation_status.ACTIVE',
      INACTIVE: 'common.activation_status.INACTIVE',
    },
    group: 'common.group',
    groups: {
      title: 'common.groups.title',
      description: 'common.groups.description',
      is_default: 'common.groups.is_default',
    },
    success: 'common.success',
    restriction_groups_create: {
      title: 'common.restriction_groups_create.title',
    },
    pin_status: 'common.pin_status',
    category: 'common.category',
  },
  confirm_reset_password: {
    title: 'confirm_reset_password.title',
    introduction: 'confirm_reset_password.introduction',
    confirm_password: 'confirm_reset_password.confirm_password',
    errors: {
      code_invalid: 'confirm_reset_password.errors.code_invalid',
      cta: 'confirm_reset_password.errors.cta',
    },
    invalid_email: 'confirm_reset_password.invalid_email',
    success: 'confirm_reset_password.success',
  },
  reset_password: {
    title: 'reset_password.title',
    introduction: 'reset_password.introduction',
  },
  set_password: {
    title: 'set_password.title',
    introduction: 'set_password.introduction',
    confirm: 'set_password.confirm',
    success: {
      title: 'set_password.success.title',
      introduction: 'set_password.success.introduction',
      cta: 'set_password.success.cta',
    },
  },
  header: {
    welcome: 'header.welcome',
    logout: 'header.logout',
    loggedAs: 'header.loggedAs',
    change_profile: 'header.change_profile',
  },
  dashboard: {
    welcome: 'dashboard.welcome',
    hello: 'dashboard.hello',
    introduction: 'dashboard.introduction',
    go_onboarding: 'dashboard.go_onboarding',
    go_onboarding_intro: 'dashboard.go_onboarding_intro',
  },
  organisation: {
    use_mobility_budget: 'organisation.use_mobility_budget',
    use_payment_card: 'organisation.use_payment_card',
  },
  operator: {
    organisations: {
      add: 'operator.organisations.add',
      title: 'operator.organisations.title',
      introduction: 'operator.organisations.introduction',
      details: {
        title: 'operator.organisations.details.title',
        kyc: {
          title: 'operator.organisations.details.kyc.title',
          reason: 'operator.organisations.details.kyc.reason',
          introduction: 'operator.organisations.details.kyc.introduction',
          not_data: 'operator.organisations.details.kyc.not_data',
          data_ok: 'operator.organisations.details.kyc.data_ok',
          uploaded_files: 'operator.organisations.details.kyc.uploaded_files',
          uploaded_files_plural:
            'operator.organisations.details.kyc.uploaded_files_plural',
          organisation_documents:
            'operator.organisations.details.kyc.organisation_documents',
          shareholder_documents:
            'operator.organisations.details.kyc.shareholder_documents',
        },
        shareholder: {
          no_documents:
            'operator.organisations.details.shareholder.no_documents',
        },
        organisation: {
          no_documents:
            'operator.organisations.details.organisation.no_documents',
        },
        no_documents: 'operator.organisations.details.no_documents',
        settings: {
          car_coefficients:
            'operator.organisations.details.settings.car_coefficients',
          bike_coefficients:
            'operator.organisations.details.settings.bike_coefficients',
          update_success: {
            title:
              'operator.organisations.details.settings.update_success.title',
            content:
              'operator.organisations.details.settings.update_success.content',
          },
          approval_limits:
            'operator.organisations.details.settings.approval_limits',
          km_allowance: 'operator.organisations.details.settings.km_allowance',
        },
      },
      force_creation: 'operator.organisations.force_creation',
      kyc_started_on: 'operator.organisations.kyc_started_on',
    },
    dashboard: {
      title: 'operator.dashboard.title',
      introduction: 'operator.dashboard.introduction',
      add_organisation: 'operator.dashboard.add_organisation',
      add_organisation_success: {
        content: 'operator.dashboard.add_organisation_success.content',
        title: 'operator.dashboard.add_organisation_success.title',
      },
      add_organisation_description:
        'operator.dashboard.add_organisation_description',
      welcome: 'operator.dashboard.welcome',
      welcome_page: {
        introduction: 'operator.dashboard.welcome_page.introduction',
        trending_title: 'operator.dashboard.welcome_page.trending_title',
      },
      validated_organisations: 'operator.dashboard.validated_organisations',
      total_organisations: 'operator.dashboard.total_organisations',
      employees_this_month: 'operator.dashboard.employees_this_month',
      table: {
        refused_organisations: 'operator.dashboard.table.refused_organisations',
        table_introduction: 'operator.dashboard.table.table_introduction',
      },
      organisations_tooltip: 'operator.dashboard.organisations_tooltip',
      validated_organisations_tooltip:
        'operator.dashboard.validated_organisations_tooltip',
      employees_tooltip: 'operator.dashboard.employees_tooltip',
      service_details: 'operator.dashboard.service_details',
    },
    employees: {
      details: {
        role: 'operator.employees.details.role',
        role_title: 'operator.employees.details.role_title',
        birthdate: 'operator.employees.details.birthdate',
        title: 'operator.employees.details.title',
        work_related_title: 'operator.employees.details.work_related_title',
        other_title: 'operator.employees.details.other_title',
        introduction: 'operator.employees.details.introduction',
        card: {
          active: 'operator.employees.details.card.active',
          blocked: 'operator.employees.details.card.blocked',
        },
        update_employee_success: {
          content: 'operator.employees.details.update_employee_success.content',
          title: 'operator.employees.details.update_employee_success.title',
        },
        social_secretary: 'operator.employees.details.social_secretary',
      },
      expenses: {
        introduction: 'operator.employees.expenses.introduction',
        is_home_work: 'operator.employees.expenses.is_home_work',
        title: 'operator.employees.expenses.title',
        created_at: 'operator.employees.expenses.created_at',
        expense_code: 'operator.employees.expenses.expense_code',
        category_code: 'operator.employees.expenses.category_code',
        expense_date: 'operator.employees.expenses.expense_date',
        details: {
          title: 'operator.employees.expenses.details.title',
        },
        operator_category: 'operator.employees.expenses.operator_category',
        swapfiets: {
          add_expense: 'operator.employees.expenses.swapfiets.add_expense',
        },
        create: {
          expense_success: {
            title: 'operator.employees.expenses.create.expense_success.title',
            content:
              'operator.employees.expenses.create.expense_success.content',
          },
        },
        update: {
          expense_success: {
            title: 'operator.employees.expenses.update.expense_success.title',
            content:
              'operator.employees.expenses.update.expense_success.content',
          },
        },
      },
      budgets: {
        type: {
          MAIN: 'operator.employees.budgets.type.MAIN',
          MOBILITY: 'operator.employees.budgets.type.MOBILITY',
          BONUS: 'operator.employees.budgets.type.BONUS',
          PRO: 'operator.employees.budgets.type.PRO',
          UNCATEGORIZED: 'operator.employees.budgets.type.UNCATEGORIZED',
          KM_ALLOWANCE: 'operator.employees.budgets.type.KM_ALLOWANCE',
          title: 'operator.employees.budgets.type.title',
          COMMUTE: 'operator.employees.budgets.type.COMMUTE',
        },
        is_carry_over_enabled: {
          true: 'operator.employees.budgets.is_carry_over_enabled.true',
          false: 'operator.employees.budgets.is_carry_over_enabled.false',
          title: 'operator.employees.budgets.is_carry_over_enabled.title',
        },
        remaining: 'operator.employees.budgets.remaining',
        total: 'operator.employees.budgets.total',
        active: 'operator.employees.budgets.active',
        future: 'operator.employees.budgets.future',
        past: 'operator.employees.budgets.past',
        number_budgets: 'operator.employees.budgets.number_budgets',
        number_budgets_plural:
          'operator.employees.budgets.number_budgets_plural',
        details: {
          introduction: 'operator.employees.budgets.details.introduction',
        },
        initial_amount: 'operator.employees.budgets.initial_amount',
        carried_over_from_previous:
          'operator.employees.budgets.carried_over_from_previous',
        blocked: 'operator.employees.budgets.blocked',
        add_budget: 'operator.employees.budgets.add_budget',
        add_budget_success: {
          title: 'operator.employees.budgets.add_budget_success.title',
          content: 'operator.employees.budgets.add_budget_success.content',
        },
        create: {
          title: 'operator.employees.budgets.create.title',
          introduction: 'operator.employees.budgets.create.introduction',
          amount: 'operator.employees.budgets.create.amount',
          is_carry_over_enabled:
            'operator.employees.budgets.create.is_carry_over_enabled',
        },
        status: {
          VALIDATED: 'operator.employees.budgets.status.VALIDATED',
          BLOCKED: 'operator.employees.budgets.status.BLOCKED',
          title: 'operator.employees.budgets.status.title',
        },
        edit: {
          title: 'operator.employees.budgets.edit.title',
          budget_success: {
            title: 'operator.employees.budgets.edit.budget_success.title',
            content: 'operator.employees.budgets.edit.budget_success.content',
          },
        },
        is_unlimited: {
          title: 'operator.employees.budgets.is_unlimited.title',
        },
        is_current: {
          title: 'operator.employees.budgets.is_current.title',
        },
      },
      programs: {
        services: {
          title: 'operator.employees.programs.services.title',
        },
      },
      archive: {
        title: 'operator.employees.archive.title',
        explanation: 'operator.employees.archive.explanation',
        status: {
          idle: 'operator.employees.archive.status.idle',
        },
      },
    },
    restriction_groups: {
      mcc_title: 'operator.restriction_groups.mcc_title',
      whitelist_total: 'operator.restriction_groups.whitelist_total',
      details: {
        mcc_title: 'operator.restriction_groups.details.mcc_title',
        mcc_category_code:
          'operator.restriction_groups.details.mcc_category_code',
        mid_title: 'operator.restriction_groups.details.mid_title',
        mid_restriction_group:
          'operator.restriction_groups.details.mid_restriction_group',
        mcc_blacklisted_title:
          'operator.restriction_groups.details.mcc_blacklisted_title',
        mid_blacklisted_title:
          'operator.restriction_groups.details.mid_blacklisted_title',
        search: {
          results: 'operator.restriction_groups.details.search.results',
          result_subtitle:
            'operator.restriction_groups.details.search.result_subtitle',
          result_add: 'operator.restriction_groups.details.search.result_add',
          result_remove:
            'operator.restriction_groups.details.search.result_remove',
        },
        success: {
          title: 'operator.restriction_groups.details.success.title',
          content: 'operator.restriction_groups.details.success.content',
        },
        status: {
          canceled: {
            explanation:
              'operator.restriction_groups.details.status.canceled.explanation',
          },
        },
      },
      mid_title: 'operator.restriction_groups.mid_title',
      blacklist_total: 'operator.restriction_groups.blacklist_total',
      total: 'operator.restriction_groups.total',
    },
    transactions: {
      payment: 'operator.transactions.payment',
      details: {
        card_reference: 'operator.transactions.details.card_reference',
        title: 'operator.transactions.details.title',
        authorization_note: 'operator.transactions.details.authorization_note',
      },
      status: {
        SETTLED: 'operator.transactions.status.SETTLED',
        ACCEPTED: 'operator.transactions.status.ACCEPTED',
        REFUSED: 'operator.transactions.status.REFUSED',
        REVERSED: 'operator.transactions.status.REVERSED',
      },
    },
    cards: {
      CardStatus: {
        LOCK: 'operator.cards.CardStatus.LOCK',
        UNLOCK: 'operator.cards.CardStatus.UNLOCK',
        STOLEN: 'operator.cards.CardStatus.STOLEN',
        LOST: 'operator.cards.CardStatus.LOST',
      },
      is_physical: 'operator.cards.is_physical',
      monthly_limit: 'operator.cards.monthly_limit',
      mcc_restriction_group: 'operator.cards.mcc_restriction_group',
      mid_restriction_group: 'operator.cards.mid_restriction_group',
      conversion: {
        tooltip_not_converted:
          'operator.cards.conversion.tooltip_not_converted',
        title: 'operator.cards.conversion.title',
        tooltip_is_converted: 'operator.cards.conversion.tooltip_is_converted',
        explanation: 'operator.cards.conversion.explanation',
        status: {
          idle: 'operator.cards.conversion.status.idle',
          success: 'operator.cards.conversion.status.success',
          loading: 'operator.cards.conversion.status.loading',
          error: 'operator.cards.conversion.status.error',
        },
      },
      block: {
        status: {
          idle: 'operator.cards.block.status.idle',
          loading: 'operator.cards.block.status.loading',
          error: 'operator.cards.block.status.error',
          success: 'operator.cards.block.status.success',
        },
        title: 'operator.cards.block.title',
        explanation: 'operator.cards.block.explanation',
      },
      lock: {
        status: {
          idle: 'operator.cards.lock.status.idle',
          loading: 'operator.cards.lock.status.loading',
          error: 'operator.cards.lock.status.error',
          success: 'operator.cards.lock.status.success',
        },
        explanation: 'operator.cards.lock.explanation',
      },
      unlock: {
        status: {
          idle: 'operator.cards.unlock.status.idle',
          loading: 'operator.cards.unlock.status.loading',
          error: 'operator.cards.unlock.status.error',
          success: 'operator.cards.unlock.status.success',
        },
      },
      add: 'operator.cards.add',
      edit: {
        title: 'operator.cards.edit.title',
        status: {
          loading: 'operator.cards.edit.status.loading',
          error: 'operator.cards.edit.status.error',
          success: 'operator.cards.edit.status.success',
        },
      },
      create: {
        title: 'operator.cards.create.title',
        confirmation: 'operator.cards.create.confirmation',
        status: {
          loading: 'operator.cards.create.status.loading',
          error: 'operator.cards.create.status.error',
          success: 'operator.cards.create.status.success',
        },
      },
      card_reference: 'operator.cards.card_reference',
      PinStatus: {
        LOCK: 'operator.cards.PinStatus.LOCK',
      },
    },
    merchants: {
      edit_merchant_success: {
        title: 'operator.merchants.edit_merchant_success.title',
        content: 'operator.merchants.edit_merchant_success.content',
      },
      details: {
        title: 'operator.merchants.details.title',
      },
    },
    services: {
      title: 'operator.services.title',
      introduction: 'operator.services.introduction',
      category_name_key: 'operator.services.category_name_key',
      providers_title: 'operator.services.providers_title',
    },
    expenses: {
      introduction: 'operator.expenses.introduction',
      title: 'operator.expenses.title',
      expense_at: 'operator.expenses.expense_at',
      expense_owner: 'operator.expenses.expense_owner',
      distance: 'operator.expenses.distance',
      created_by: 'operator.expenses.created_by',
      review_status: 'operator.expenses.review_status',
      refund_status: 'operator.expenses.refund_status',
      program: 'operator.expenses.program',
      service: 'operator.expenses.service',
      provider: 'operator.expenses.provider',
      justification: 'operator.expenses.justification',
      expense_code: 'operator.expenses.expense_code',
      attachment: 'operator.expenses.attachment',
      review_comment: 'operator.expenses.review_comment',
    },
    pin: {
      block: {
        status: {
          idle: 'operator.pin.block.status.idle',
          loading: 'operator.pin.block.status.loading',
          error: 'operator.pin.block.status.error',
          success: 'operator.pin.block.status.success',
        },
        title: 'operator.pin.block.title',
        explanation: 'operator.pin.block.explanation',
      },
      PinStatus: {
        UNLOCK: 'operator.pin.PinStatus.UNLOCK',
        LOCK: 'operator.pin.PinStatus.LOCK',
        STOLEN: 'operator.pin.PinStatus.STOLEN',
        LOST: 'operator.pin.PinStatus.LOST',
      },
    },
  },
  employees_form: {
    title: 'employees_form.title',
    introduction: 'employees_form.introduction',
    template_link: 'employees_form.template_link',
    success: {
      title: 'employees_form.success.title',
    },
    short_introduction: 'employees_form.short_introduction',
    report: {
      title: 'employees_form.report.title',
      importReadyRows: 'employees_form.report.importReadyRows',
      importAllRows: 'employees_form.report.importAllRows',
      downloadReport: 'employees_form.report.downloadReport',
      startAnalysis: 'employees_form.report.startAnalysis',
      result: 'employees_form.report.result',
      chooseFile: 'employees_form.report.chooseFile',
    },
    structure_errors: {
      title: 'employees_form.structure_errors.title',
    },
    retry: 'employees_form.retry',
    importSuccess: 'employees_form.importSuccess',
    template: {
      title: 'employees_form.template.title',
      description: 'employees_form.template.description',
    },
  },
  http_errors: {
    booking_create_registration_email_required:
      'http_errors.booking_create_registration_email_required',
    booking_create_registration_email_already_exists:
      'http_errors.booking_create_registration_email_already_exists',
    booking_create_registration_user_already_exists:
      'http_errors.booking_create_registration_user_already_exists',
    booking_create_registration_phone_number_required:
      'http_errors.booking_create_registration_phone_number_required',
    booking_create_registration_firstname_required:
      'http_errors.booking_create_registration_firstname_required',
    booking_create_registration_lastname_required:
      'http_errors.booking_create_registration_lastname_required',
    booking_create_registration_gender_required:
      'http_errors.booking_create_registration_gender_required',
    booking_create_registration_date_of_birth_required:
      'http_errors.booking_create_registration_date_of_birth_required',
    booking_create_registration_nationality_required:
      'http_errors.booking_create_registration_nationality_required',
    booking_create_registration_place_of_birth_required:
      'http_errors.booking_create_registration_place_of_birth_required',
    booking_create_registration_country_of_birth_required:
      'http_errors.booking_create_registration_country_of_birth_required',
    booking_create_registration_job_title_required:
      'http_errors.booking_create_registration_job_title_required',
    booking_create_registration_role_required:
      'http_errors.booking_create_registration_role_required',
    booking_create_registration_start_on_required:
      'http_errors.booking_create_registration_start_on_required',
    booking_create_registration_language_required:
      'http_errors.booking_create_registration_language_required',
    booking_create_registration_address_required:
      'http_errors.booking_create_registration_address_required',
    booking_create_registration_email_invalid:
      'http_errors.booking_create_registration_email_invalid',
    booking_create_registration_gender_invalid:
      'http_errors.booking_create_registration_gender_invalid',
    booking_create_registration_country_code_invalid:
      'http_errors.booking_create_registration_country_code_invalid',
    booking_create_registration_role_invalid:
      'http_errors.booking_create_registration_role_invalid',
    booking_create_registration_language_invalid:
      'http_errors.booking_create_registration_language_invalid',
    booking_create_registration_address_invalid:
      'http_errors.booking_create_registration_address_invalid',
    booking_create_registration_start_on_invalid:
      'http_errors.booking_create_registration_start_on_invalid',
    booking_create_registration_date_of_birth_invalid:
      'http_errors.booking_create_registration_date_of_birth_invalid',
    booking_create_registration_must_be_over_18:
      'http_errors.booking_create_registration_must_be_over_18',
    booking_update_registration_firstname_required:
      'http_errors.booking_update_registration_firstname_required',
    booking_update_registration_lastname_required:
      'http_errors.booking_update_registration_lastname_required',
    booking_update_registration_gender_required:
      'http_errors.booking_update_registration_gender_required',
    booking_update_registration_date_of_birth_required:
      'http_errors.booking_update_registration_date_of_birth_required',
    booking_update_registration_nationality_required:
      'http_errors.booking_update_registration_nationality_required',
    booking_update_registration_place_of_birth_required:
      'http_errors.booking_update_registration_place_of_birth_required',
    booking_update_registration_country_of_birth_required:
      'http_errors.booking_update_registration_country_of_birth_required',
    booking_update_registration_job_title_required:
      'http_errors.booking_update_registration_job_title_required',
    booking_update_registration_role_required:
      'http_errors.booking_update_registration_role_required',
    booking_update_registration_start_on_required:
      'http_errors.booking_update_registration_start_on_required',
    booking_update_registration_language_required:
      'http_errors.booking_update_registration_language_required',
    booking_update_registration_address_required:
      'http_errors.booking_update_registration_address_required',
    booking_update_registration_email_invalid:
      'http_errors.booking_update_registration_email_invalid',
    booking_update_registration_gender_invalid:
      'http_errors.booking_update_registration_gender_invalid',
    booking_update_registration_country_code_invalid:
      'http_errors.booking_update_registration_country_code_invalid',
    booking_update_registration_role_invalid:
      'http_errors.booking_update_registration_role_invalid',
    booking_update_registration_language_invalid:
      'http_errors.booking_update_registration_language_invalid',
    booking_update_registration_address_invalid:
      'http_errors.booking_update_registration_address_invalid',
    booking_update_registration_start_on_invalid:
      'http_errors.booking_update_registration_start_on_invalid',
    booking_update_registration_date_of_birth_invalid:
      'http_errors.booking_update_registration_date_of_birth_invalid',
    booking_update_registration_must_be_over_18:
      'http_errors.booking_update_registration_must_be_over_18',
    booking_handle_registration_csv_not_enough_privileges:
      'http_errors.booking_handle_registration_csv_not_enough_privileges',
    booking_handle_registration_csv_error_mismatch_column:
      'http_errors.booking_handle_registration_csv_error_mismatch_column',
    booking_common_user_not_found: 'http_errors.booking_common_user_not_found',
    booking_handle_registration_csv_error_parsing_csv:
      'http_errors.booking_handle_registration_csv_error_parsing_csv',
    organisation_common_image_decode_failed:
      'http_errors.organisation_common_image_decode_failed',
    organisation_create_employee_email_required:
      'http_errors.organisation_create_employee_email_required',
    organisation_create_employee_phone_number_required:
      'http_errors.organisation_create_employee_phone_number_required',
    organisation_create_employee_firstname_required:
      'http_errors.organisation_create_employee_firstname_required',
    organisation_create_employee_lastname_required:
      'http_errors.organisation_create_employee_lastname_required',
    organisation_create_employee_gender_required:
      'http_errors.organisation_create_employee_gender_required',
    organisation_create_employee_date_of_birth_required:
      'http_errors.organisation_create_employee_date_of_birth_required',
    organisation_create_employee_nationality_required:
      'http_errors.organisation_create_employee_nationality_required',
    organisation_create_employee_place_of_birth_required:
      'http_errors.organisation_create_employee_place_of_birth_required',
    organisation_create_employee_country_of_birth_required:
      'http_errors.organisation_create_employee_country_of_birth_required',
    organisation_create_employee_job_title_required:
      'http_errors.organisation_create_employee_job_title_required',
    organisation_create_employee_role_required:
      'http_errors.organisation_create_employee_role_required',
    organisation_create_employee_start_on_required:
      'http_errors.organisation_create_employee_start_on_required',
    organisation_create_employee_language_required:
      'http_errors.organisation_create_employee_language_required',
    organisation_create_employee_address_required:
      'http_errors.organisation_create_employee_address_required',
    organisation_create_employee_email_invalid:
      'http_errors.organisation_create_employee_email_invalid',
    organisation_create_employee_gender_invalid:
      'http_errors.organisation_create_employee_gender_invalid',
    organisation_create_employee_country_code_invalid:
      'http_errors.organisation_create_employee_country_code_invalid',
    organisation_create_employee_role_invalid:
      'http_errors.organisation_create_employee_role_invalid',
    organisation_create_employee_language_invalid:
      'http_errors.organisation_create_employee_language_invalid',
    organisation_create_employee_address_invalid:
      'http_errors.organisation_create_employee_address_invalid',
    organisation_create_employee_start_on_invalid:
      'http_errors.organisation_create_employee_start_on_invalid',
    organisation_create_employee_date_of_birth_invalid:
      'http_errors.organisation_create_employee_date_of_birth_invalid',
    organisation_create_employee_must_be_over_18:
      'http_errors.organisation_create_employee_must_be_over_18',
    organisation_common_get_document_data_failed:
      'http_errors.organisation_common_get_document_data_failed',
    organisation_get_organisation_informations_vat_not_found:
      'http_errors.organisation_get_organisation_informations_vat_not_found',
    authentication_verify_password_token_invalid_token:
      'http_errors.authentication_verify_password_token_invalid_token',
    booking_create_organisation_from_vat_legal_sector_required:
      'http_errors.booking_create_organisation_from_vat_legal_sector_required',
    booking_create_organisation_from_vat_registration_date_required:
      'http_errors.booking_create_organisation_from_vat_registration_date_required',
    booking_create_organisation_from_vat_legal_form_required:
      'http_errors.booking_create_organisation_from_vat_legal_form_required',
    booking_create_organisation_from_vat_legal_name_required:
      'http_errors.booking_create_organisation_from_vat_legal_name_required',
    booking_create_registration_user_already_exists_as_b2b:
      'http_errors.booking_create_registration_user_already_exists_as_b2b',
    authentication_wrong_password: 'http_errors.authentication_wrong_password',
    authentication_user_not_found: 'http_errors.authentication_user_not_found',
    wallet_create_virtual_card_user_has_already_card:
      'http_errors.wallet_create_virtual_card_user_has_already_card',
    booking_create_budget_budget_overlap:
      'http_errors.booking_create_budget_budget_overlap',
    booking_update_budget_budget_type_invalid:
      'http_errors.booking_update_budget_budget_type_invalid',
    wallet_get_organisation_informations_vat_not_found:
      'http_errors.wallet_get_organisation_informations_vat_not_found',
    booking_update_registration_registration_not_editable:
      'http_errors.booking_update_registration_registration_not_editable',
    booking_update_budget_budget_cannot_span_on_several_years:
      'http_errors.booking_update_budget_budget_cannot_span_on_several_years',
    booking_create_budget_budget_cannot_span_on_several_years:
      'http_errors.booking_create_budget_budget_cannot_span_on_several_years',
    booking_create_virtual_card_bank_reference_required:
      'http_errors.booking_create_virtual_card_bank_reference_required',
    booking_update_budget_budget_expired_cannot_update_total:
      'http_errors.booking_update_budget_budget_expired_cannot_update_total',
    wallet_update_mid_restriction_group_restriction_group_not_editable:
      'http_errors.wallet_update_mid_restriction_group_restriction_group_not_editable',
    wallet_update_mcc_restriction_group_restriction_group_not_editable:
      'http_errors.wallet_update_mcc_restriction_group_restriction_group_not_editable',
  },
  wallet_form: {
    short_introduction: 'wallet_form.short_introduction',
    introduction: 'wallet_form.introduction',
    title: 'wallet_form.title',
    beneficiary_name: 'wallet_form.beneficiary_name',
  },
  http_erros: {
    booking_update_shareholder_cannot_update_confirmed_shareholder:
      'http_erros.booking_update_shareholder_cannot_update_confirmed_shareholder',
  },
  authentication: {
    error: {
      title: 'authentication.error.title',
    },
  },
  pager: {
    entries: 'pager.entries',
    rows_per_page: 'pager.rows_per_page',
  },
  automated_expense_threshold_fr: 'automated_expense_threshold_fr',
  settings_expenses_title_fr: 'settings_expenses_title_fr',
  automated_expense_approval_card_fr: 'automated_expense_approval_card_fr',
  automated_expense_approval_card_sub_fr:
    'automated_expense_approval_card_sub_fr',
  automated_expense_approval_app_fr: 'automated_expense_approval_app_fr',
  automated_expense_approval_app_sub_fr:
    'automated_expense_approval_app_sub_fr',
  employees: {
    details: {
      topup: {
        table: {
          carry_over: 'employees.details.topup.table.carry_over',
          budget_distribution: {
            title: 'employees.details.topup.table.budget_distribution.title',
          },
        },
      },
    },
  },
};
